<template>
  <div class="nx-relation-card-tools"
       :class="relationCardToolsClasses">
    <v-layout>
      <v-flex class="px-0 py-2">
        <slot name="default"></slot>
      </v-flex>
      <v-flex shrink class="nx-relation-card-tools__actions py-2"
              :class="relationCardToolsActionClasses"
              v-if="showTools">

        <v-layout class="column fill-height">
          <v-tooltip left>
            <v-btn v-if="collapsable" class="px-0 mx-0"
                   icon @click="collapse" slot="activator">
              <v-icon color="primary">compress</v-icon>
            </v-btn>
            <span v-html="$t('message.relation.hide')"></span>
          </v-tooltip>
          <v-tooltip left>
            <v-btn v-if="!disableSort" class="px-0 mx-0"
                   icon :disabled="first || disabled" @click="moveUp" slot="activator">
              <v-icon color="primary">arrow_upward</v-icon>
            </v-btn>
            <span v-html="$t('message.relation.moveUp')"></span>
          </v-tooltip>
          <v-tooltip left>
            <v-btn v-if="!disableSort" class="px-0 mx-0"
                   icon :disabled="last || disabled" @click="moveDown" slot="activator">
              <v-icon color="primary">arrow_downward</v-icon>
            </v-btn>
            <span v-html="$t('message.relation.moveDown')"></span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <v-btn v-if="!disableDelete" class="px-0 mx-0"
                   icon @click="remove" :disabled="disabled" slot="activator">
              <v-icon color="primary">delete</v-icon>
            </v-btn>
            <span v-html="$t('message.relation.delete')"></span>
          </v-tooltip>
        </v-layout>

      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'nx-relation-card-tools',
  props: {
    count: Number,
    collapsable: Boolean,
    hideTools: Boolean,
    disabled: Boolean,
    position: Number,
    disableSort: Boolean,
    disableDelete: Boolean,
    darkTheme: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showTools() {
      if (this.hideTools) {
        return false;
      }
      return !(this.disableSort && this.disableDelete);
    },
    first() {
      return this.position === 0;
    },
    last() {
      return this.position === (this.count - 1);
    },
    relationCardToolsClasses() {
      if (this.darkTheme) return 'white';
      return 'nx-primary--lighten-5';
    },
    relationCardToolsActionClasses() {
      if (this.darkTheme) return 'nx-neutral--200';
      return 'nx-primary--lighten-4';
    },
  },
  methods: {
    moveDown() {
      this.$emit('move-down');
    },
    moveUp() {
      this.$emit('move-up');
    },
    remove() {
      this.$emit('remove');
    },
    collapse() {
      this.$emit('collapse');
    },
  },
};
</script>

<style lang="stylus">
.nx-relation-card-tools {
  transition: all .5s;
  will-change: transform;
  &__actions {
    padding: 0 2px;
    box-shadow: inset 1px 0 0 0 #e1e1e6;
  }

  .nx-neutral--200 {
    background-color: #D1D1DE !important;
    border-color: #D1D1DE !important;
  }
}
</style>
